import * as Yup from 'yup'

const paypalValidation = Yup.object().shape({
  firstName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
  lastName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  contactNumber: Yup.number().typeError('Must be a number').required('Required'),
})

const cardValidation = Yup.object().shape({
  firstName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
  lastName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  contactNumber: Yup.number().typeError('Must be a number').required('Required').positive().integer(),
  // cardNumber: Yup.number().typeError('Must be a number').required('Required'),
  // cardCVV: Yup.number().typeError('Must be a number').required('Required'),
  // expiryMonth: Yup.number().typeError('Must be a number').required('Required'),
  // expiryYear: Yup.number().typeError('Must be a number').required('Required'),
})

export { paypalValidation, cardValidation }
